import { Children } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Fade } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionColumn,
        ...theme.mixins.flex.alignItemsCenter,
        ...theme.mixins.flex.justifyContentCenter,

        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10,

        '@media print': {
            display: 'block',
            position: 'static',
        },
    },
}));

export default function StatusTextContainer(props) {
    const { children } = props;
    const classes = useStyles();

    const hasChildren = Children.count(children) > 0;

    return (
        <div className={classes.root}>
            <Fade in={hasChildren} timeout={200}>
                <div>{children}</div>
            </Fade>
        </div>
    );
}
